import { useMutation, useQueryClient } from 'react-query';
import {
  createBettieFeedComment,
  type CreateBettieFeedCommentBody,
  type CreateBettieFeedCommentResponse
} from '../../services/bettieFeedService';

type CreateBettieFeedCommentVariables = {
  chatRoomId: string;
  postId: string;
  body: CreateBettieFeedCommentBody;
};

export function useCreateBettieFeedComment() {
  const queryClient = useQueryClient();

  return useMutation<CreateBettieFeedCommentResponse, Error, CreateBettieFeedCommentVariables>(
    ({ chatRoomId, postId, body }) => createBettieFeedComment(chatRoomId, postId, body),
    {
      onSuccess: (_data, variables) => {
        queryClient.invalidateQueries([
          'bettieFeedComments',
          variables.chatRoomId,
          variables.postId
        ]);
        queryClient.invalidateQueries(['bettieFeedPost', variables.chatRoomId, variables.postId]);
        queryClient.invalidateQueries(['bettieFeedPosts', variables.chatRoomId]);
      }
    }
  );
}
